<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="m30 16-4.79 4.79a.71.71 0 0 1-1.21-.5V17.5h-6.5V24h2.79c.63 0 .95.77.5 1.21L16 30l-4.79-4.79a.71.71 0 0 1 .5-1.21h2.79v-6.5H8v2.79a.7.7 0 0 1-1.21.5L2 16l4.79-4.79a.71.71 0 0 1 1.21.5v2.79h6.5V8h-2.79a.71.71 0 0 1-.5-1.21L16 2l4.79 4.79a.71.71 0 0 1-.5 1.21H17.5v6.5H24v-2.79c0-.63.77-.95 1.21-.5z"/></svg>
</template>
